module.exports = __webpack_public_path__ + "img/resources.9e45d3af.svg";